<template>
    <el-dialog title="申请退款" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="交易订单号：" :label-width="formLabelWidth">
                <el-input v-model="form.dealTradeNo" autocomplete="off" placeholder="请输入交易订单号"></el-input>
            </el-form-item>
            <el-form-item label="商户订单号：" :label-width="formLabelWidth">
                <el-input v-model="form.outTradeNo" autocomplete="off" placeholder="请输入商户订单号"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmRefund">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        dealTradeNo: '',
        outTradeNo: '',
      },
      formLabelWidth: '120px',
    };
  },
  methods: {
     ...mapActions('trading', ['businessRefund']),
    openRefundDialog() {
      this.dialogFormVisible = true;
    },
    confirmRefund() {
      this.dialogFormVisible = false;
      this.businessRefund(this.form)
    },
  },
};
</script>
<style lang="less" scoped>
</style>